import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIStore {
    isFancyCheckinRendered: boolean;
    reset: () => void;
}

const initialState = {
    isFancyCheckinRendered: false,
};

export const useUIStore = create<UIStore>()(
    persist(
        (set) => ({
            ...initialState,
            reset: (): void => set({ ...initialState }),
        }),
        {
            name: 'ui_store',
        }
    )
);
